/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { MessageBoxContainer_story$ref } from "./MessageBoxContainer_story.graphql";
export type STORY_MODE = "COMMENTS" | "QA" | "%future added value";
declare const _PostCommentFormContainer_story$ref: unique symbol;
export type PostCommentFormContainer_story$ref = typeof _PostCommentFormContainer_story$ref;
export type PostCommentFormContainer_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly settings: {
        readonly messageBox: {
            readonly enabled: boolean;
        };
        readonly mode: STORY_MODE;
    };
    readonly " $fragmentRefs": MessageBoxContainer_story$ref;
    readonly " $refType": PostCommentFormContainer_story$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PostCommentFormContainer_story",
    "type": "Story",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isClosed",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "settings",
            "storageKey": null,
            "args": null,
            "concreteType": "StorySettings",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "messageBox",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoryMessageBox",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "enabled",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "mode",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "MessageBoxContainer_story",
            "args": null
        }
    ]
} as any);
(node as any).hash = '0fea875e221c87d14fe9404fd26816e7';
export default node;
